/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { EntityOrigin } from './EntityOrigin';
import {
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';

/**
 * 
 * @export
 * @interface TextValueListDto
 */
export interface TextValueListDto {
    /**
     * 
     * @type {string}
     * @memberof TextValueListDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TextValueListDto
     */
    dataTypeId?: string;
    /**
     * 
     * @type {string}
     * @memberof TextValueListDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TextValueListDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {EntityOrigin}
     * @memberof TextValueListDto
     */
    origin?: EntityOrigin;
    /**
     * 
     * @type {Array<string>}
     * @memberof TextValueListDto
     */
    availableValues?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TextValueListDto
     */
    selectedValues?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof TextValueListDto
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TextValueListDto
     */
    $type?: TextValueListDtoTypeEnum;
}


/**
 * @export
 */
export const TextValueListDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoSystemSetupParametersTextValueListDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.TextValueListDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type TextValueListDtoTypeEnum = typeof TextValueListDtoTypeEnum[keyof typeof TextValueListDtoTypeEnum];



/**
 * Check if a given object implements the TextValueListDto interface.
 */
export function instanceOfTextValueListDto(value?: unknown): value is TextValueListDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(TextValueListDtoTypeEnum)[0];
}

export function TextValueListDtoFromJSON(json: any): TextValueListDto {
    return TextValueListDtoFromJSONTyped(json, false);
}

export function TextValueListDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TextValueListDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'dataTypeId': json['dataTypeId'] == null ? undefined : json['dataTypeId'],
        'name': json['name'] == null ? undefined : json['name'],
        'iuid': json['iuid'] == null ? undefined : json['iuid'],
        'origin': json['origin'] == null ? undefined : EntityOriginFromJSON(json['origin']),
        'availableValues': json['availableValues'] == null ? undefined : json['availableValues'],
        'selectedValues': json['selectedValues'] == null ? undefined : json['selectedValues'],
        'isEnabled': json['isEnabled'] == null ? undefined : json['isEnabled'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function TextValueListDtoToJSON(value?: TextValueListDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'dataTypeId': value['dataTypeId'],
        'name': value['name'],
        'iuid': value['iuid'],
        'origin': EntityOriginToJSON(value['origin']),
        'availableValues': value['availableValues'],
        'selectedValues': value['selectedValues'],
        'isEnabled': value['isEnabled'],
        '$type': value['$type'],
    });
}

